let domain = (process.env.NODE_ENV == "production") ? window.location.protocol + "//" + window.location.hostname + "/index.php" : "https://as.wearenotalone.fr/index.php" ;
export const DOMAIN_TITLE = 'Androlus Studio';
export const DOMAIN = domain;
export const WWW_IMAGE_PATH = domain +`/images/`;
//export const DOMAIN = `http://www.androlusstudio.com/index.php`;
export const API_URL = `${DOMAIN}`;
// export const API_PORT = `5000`;
// export const API_URL = `${DOMAIN}:${API_PORT}`;



// WEBPACK FOOTER //
// ./src/config/env.js